import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { Trophy } from "lucide-react";
import { supabase } from "@/integrations/supabase/client";

interface HibridoGamesLinkProps {
  variant?: "header" | "button";
  className?: string;
}

export default function HibridoGamesLink({ variant = "button", className = "" }: HibridoGamesLinkProps) {
  const { data: event } = useQuery({
    queryKey: ["hibrido-games-event"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("events")
        .select("id, slug")
        .ilike("name", "%híbrido games%")
        .eq("status", "published")
        .maybeSingle();
      if (error) throw error;
      return data;
    },
  });

  if (!event) return null;

  const href = `/leaderboard/${event.slug}`;

  if (variant === "header") {
    return (
      <Link
        to={href}
        className={`flex items-center gap-2 px-4 py-2 text-sm font-bold uppercase tracking-wider text-primary hover:text-primary/80 transition-colors ${className}`}
      >
        <Trophy size={16} />
        <span className="hidden sm:inline">Híbrido Games</span>
        <span className="sm:hidden">Ranking</span>
      </Link>
    );
  }

  return (
    <Link
      to={href}
      className={`bg-primary text-primary-foreground font-bold uppercase tracking-wider text-xs px-6 py-2.5 hover:shadow-[0_0_20px_hsl(0_100%_42%/0.3)] transition-all inline-flex items-center gap-2 ${className}`}
    >
      <Trophy size={14} />
      <span>Ranking Híbrido Games</span>
    </Link>
  );
}
